import { fmtCurrencyBR, fmtNumberBR } from "../../utils/formatBrl";

export const RankingItem = ({ position, name, count, revenue }) => {
    const positionClass = position === 1 ? 'first' : position === 2 ? 'second' : position === 3 ? 'third' : 'other';
    return (
        <div className="ranking-item">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                <div className={`ranking-position ${positionClass}`}>{position}</div>
                <div className="ranking-info">
                    <div className="ranking-name">{name}</div>
                    <div className="ranking-details">{count} vendas</div>
                </div>
            </div>
            <div className="ranking-value">
                <div className="ranking-count">{fmtCurrencyBR.format(revenue)}</div>
            </div>
        </div>
    );
};